export default __webpack_public_path__ + "static/media/ic_quest.fecf4b59.svg";